import { Link, StaticQuery, graphql } from "gatsby"
import PropTypes from "prop-types"
// import Context from "../store/context"
// import useDarkMode from '@oceanprotocol/use-dark-mode';

import { useHasMounted } from '../utils/hooks';
import { useDarkMode } from '../utils/darkMode';

import React, { useState } from "react"

const Header = ({ siteTitle }) => {
  // const {state, dispatch} = useContext(Context)
  //
  // const darkMode = useDarkMode(false, {
  //     classNameDark: 'dark',
  //     classNameLight: 'light'
  // });

  const hasMounted = useHasMounted();
  //const [mode, {toggle}] = useDarkMode();
  const [darkMode, { toggle }] = useDarkMode();


  const [isExpanded, toggleExpansion] = useState(false)
  const Nav = (
    <>
      <StaticQuery
        query={graphql`
          query {
            allStrapiNavigation(sort: {order: ASC}) {
              nodes {
                id
                title
                path
                type
                menuAttached
                related {
                  id
                  publishedAt
                }
                items {
                  id
                  title
                  path
                  type
                  menuAttached
                  related {
                    publishedAt
                    id
                  }
                  items {
                    id
                    title
                    path
                    type
                    menuAttached
                    related {
                      publishedAt
                      id
                    }
                  }
                }
              }
            }
          }
        `}
        render={data => {
          let linkstyle = "transition duration-200 ease-out block bg-zinc-800 lg:hover:bg-sky-700 lg:rounded-full px-4 py-2 mt-4 mr-2 text-zinc-300 hover:text-white lg:text-white lg:inline-block lg:mt-0"
          let wrappedlinkstyle = "block mt-4 first:mt-0 lg:first:mt-2 ml-4 lg:ml-0 py-2 lg:py-0 px-4 text-zinc-300 lg:my-3 hover:text-white"

          function navItem(item, parent, depth) {
            depth = depth + 1
            let unwrappedgroup = `static lg:relative ${depth == 1 ? 'group/outer' : 'group/inner'} block lg:inline-block mt-4 lg:mt-0 lg:pb-4 mr-2 pb-2 dropdown`
            let wrappedgroup = `static lg:relative ${depth == 1 ? 'group/outer' : 'group/inner'} block ml-4 lg:ml-0 mt-4 lg:mt-0 dropdown-nested`
            let unwrappedlink = `transition duration-200 ease-out block text-sm font-semibold lg:font-normal lg:text-sm uppercase lg:normal-case cursor-pointer bg-zinc-800 ${depth == 1 ? 'lg:group-hover/outer:bg-sky-700' : 'lg:group-hover/inner:bg-sky-700'} text-white lg:rounded-full mx-4 lg:mx-0 lg:px-4  py-2 border-zinc-600 border-b-2 lg:border-0`
            let wrappedlink = "block mt-4 ml-4 lg:ml-0 lg:pl-4 pr-3 pb-2 lg:pb-0 mr-4 lg:mr-0 lg:my-3 text-white lg:text-zinc-300 lg:hover:text-white border-zinc-600 border-b-2 lg:border-b-0 lg:border-r-4 text-sm font-semibold lg:font-normal lg:text-sm uppercase text-left lg:text-right lg:normal-case"
            let unwrappedgroupmenu = `lg:absolute lg:hidden ${depth == 1 ? 'group-hover/outer:block' : 'group-hover/inner:block'} right-0 lg:mt-2 z-50 block lg:w-52 lg:py-2 lg:bg-zinc-300 lg:bg-zinc-900 text-zinc-300 lg:rounded-xl lg:shadow-xl dropdown-menu`
            let wrappedgroupmenu = `lg:absolute lg:hidden ${depth == 1 ? 'group-hover/outer:block' : 'group-hover/inner:block'} right-2 xl:-top-2 xl:left-52 lg:-mt-3 xl:mt-2 z-50 block lg:w-48 lg:py-2 lg:bg-zinc-300 lg:bg-zinc-800 text-zinc-300 lg:rounded-tl-xl xl:rounded-tl-none lg:rounded-bl-xl lg:rounded-br-xl lg:rounded-tr-xl lg:shadow-xl dropdown-menu-nested`

            if (item.menuAttached === true) {
              let subItems = (<></>)
              if (item.items && Array.isArray(item.items) && item.items.length !== 0) {
                subItems = item.items.map(sub_item => {
                  return navItem(sub_item, item, depth)
                })
              }

              if (item.type === "INTERNAL" && item.related !== null && item.related.publishedAt !== null) {
                return (
                  <Link key={item.id} onClick={() => toggleExpansion(false)} className={parent && parent.type === "WRAPPER" ? wrappedlinkstyle : linkstyle} to={`${item.path}`}>{item.title}</Link>
                )
              } else if (item.type === "EXTERNAL") {
                return (
                  <a key={item.id} onClick={() => toggleExpansion(false)} className={parent && parent.type === "WRAPPER" ? wrappedlinkstyle : linkstyle} href={`${item.path}`}>{item.title}</a>
                )
              } else if (item.type === "WRAPPER") {
                return (
                  <div key={item.id} className={parent && parent.type === "WRAPPER" ? wrappedgroup : unwrappedgroup}>
                    <div tabIndex="0" className={parent && parent.type === "WRAPPER" ? wrappedlink : unwrappedlink}>{item.title}</div>
                    <div className={parent && parent.type === "WRAPPER" ? wrappedgroupmenu : unwrappedgroupmenu}>
                      {subItems}
                    </div>
                  </div>
                )
              } else { return (<></>) }
            }
            else { return (<></>) }
          }

          return (<>
            <Link onClick={() => toggleExpansion(false)} className={linkstyle} to="/">Home</Link>
            {data.allStrapiNavigation.nodes.map(edge => {
              return navItem(edge, undefined, 0)
            })}
          </>)
        }}
      />
    </>
  )

  return (
    <nav className="">



      <div className="container max-w-7xl mx-auto flex justify-between px-6 pt-6 mb-6 pr-20 lg:pr-4 relative">
        <div className="max-w-80 w-full flex justify-start items-center flex-shrink mr-6 text-white">
          <span className="block lg:text-xl font-semibold tracking-tight">
            {/* {darkMode.value ? (<img className=""src={logoLight} alt="logo" />) :(<img src={logoDark} alt="logo" />) } */}
            <Link
              aria-label="Navigate Home"
              to="/">
              <svg alt="Logo" fill="currentColor" viewBox="0 0 819 166" style={{ filter: "drop-shadow(0px 2.5px 5px rgba(0,0,0,0.5))" }} className="block h-auto w-full mr-auto">
                <use xlinkHref={`#logo`}></use>
              </svg>
            </Link>

          </span>
        </div>

        <div className={`${isExpanded ? `block` : `hidden`} z-40 w-screen h-screen lg:h-fit lg:w-full fixed top-0 left-0 lg:static flex-grow lg:flex lg:items-center lg:w-auto bg-zinc-100 bg-zinc-800 lg:bg-transparent lg:bg-transparent`} >
          <div className="h-screen py-14 lg:py-0 lg:h-fit overflow-y-scroll lg:overflow-visible text-xl lg:text-sm lg:flex-grow lg:text-right">
            {Nav}
          </div>
        </div>
        <button
          onClick={toggle}
          aria-label="Toggle Dark Mode"
          className="transition duration-200 ease-out self-start  p-2 rounded-full inline-block bg-zinc-800 text-white hover:bg-sky-700 " >
          <svg fill="currentColor" className="w-5 h-5">
            <use xlinkHref={`${darkMode ? "#icon-light-mode" : "#icon-dark-mode"}`}></use>
            {/* <use xlinkHref={`${state.isDark ? "#icon-light-mode" : "#icon-dark-mode"}`}></use> */}
          </svg>
        </button>
      </div>

      {/* MOBILE MENU BUTTON */}
      <div className="fixed right-4 top-0 z-50 lg:hidden">
        <button
          onClick={() => toggleExpansion(!isExpanded)}
          aria-label="Open Mobile Menu"
          className={`px-3 pt-8 pb-6 text-white ${isExpanded ? `bg-zinc-100 hover:text-zinc-300` : `bg-zinc-900 hover:text-zinc-300`} rounded-b-full`}
        >
          <span className={`${isExpanded ? `translate-y-2 rotate-45 border-zinc-800` : `border-zinc-100`} transition-all block w-6 h-1 border-b-2`}></span>
          <span className={`${isExpanded ? `!w-0 translate-x-3 border-zinc-800` : `border-zinc-100 `} transition-all block mt-1 w-6 h-1 border-b-2`}></span>
          <span className={`${isExpanded ? `-translate-y-2 -rotate-45 border-zinc-800` : `border-zinc-100 `} transition-all block mt-1 w-6 h-1 border-b-2`}></span>
        </button>
      </div>
    </nav>
  )
}
// onClick={() => dispatch({ type: "TOGGLE_DARK_MODE" })} className="absolute transition duration-200 ease-out hover:scale-125 top-[1.65rem] lg:top-7  right-20 lg:right-6 inline-block text-zinc-900 hover:text-zinc-700 dark:text-white dark:hover:text-zinc-300 " >

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
